import React, { useState } from 'react';
import AddUserForm from './AddUserForm';
import UserImport from '../user/UserImport';
import '../../assets/css/forms/AddUserTabbedForm.scss';

const AddUserTabbedForm = ({ isOpen, onClose, onUserAdded, onUsersImported }) => {
  const [activeTab, setActiveTab] = useState('addUser');

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-user-tabbed" onClick={(e) => e.stopPropagation()}>
        
        {/* Header Tabs */}
        <div className="tabs-header" onClick={(e) => e.stopPropagation()}>
          <button
            className={`tab-button ${activeTab === 'addUser' ? 'active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              setActiveTab('addUser');
            }}
          >
            Add New User
          </button>

          <button
            className={`tab-button ${activeTab === 'importUsers' ? 'active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              setActiveTab('importUsers');
            }}
          >
            Import Users
          </button>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {activeTab === 'addUser' && (
            <AddUserForm
              isOpen={true}
              onClose={onClose}
              onUserAdded={onUserAdded}
            />
          )}

          {activeTab === 'importUsers' && (
            <UserImport
              embedded={true}
              show={true}
              onUsersImported={onUsersImported}
              onClose={onClose}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AddUserTabbedForm;
